<div class="d-flex w-full justify-content-between pt-2 py-2">
  <div class="col-sm-12 col-lg-2 col-xl-2 pl-4 d-flex align-items-center">
    <h1 class="admin-header">Import Errors</h1>
  </div>
  <div class="col-sm-12 col-lg-3 col-xl-2 align-self-end">
    <label class="font-weight-bold">Client:</label>
    <mat-select
      placeholder="-- Select A Client --"
      class="btn btn-primary avi-btn py-2 px-2 client-select"
      (selectionChange)="clientChanged($event)"
      aria-label="Client Select"
      [disabled]="(allClients$ | async) === undefined"
      [value]="currentClient$ | async"
      [compareWith]="compareClientOption"
	  disableOptionCentering=""
      >
      @for (client of allClients$ | async; track client) {
        <mat-option class="client-mat-option" [value]="client"
          >{{ client.name ?? client.text }}
        </mat-option>
      }
    </mat-select>
  </div>

  <div class="col-sm-12 col-lg-3 col-xl-2 align-self-end">
    <label class="font-weight-bold">Location <span class="font-weight-normal small">(Optional)</span>:</label>
    <mat-select
      placeholder="-- Select A Location --"
      class="btn avi-btn py-2 px-2 location-select"
      [ngClass]="(isLocationDisabled$ | async) ? 'btn-secondary': 'btn-primary'"
      (selectionChange)="locationChanged($event)"
      aria-label="Location Select"
      [disabled]="(isLocationDisabled$ | async)"
      disableOptionCentering
      >
      @for (location of clientService.currentClientLocations$ | async; track location.id) {
        <mat-option
          class="location-mat-option"
          [value]="location.id"
          >{{ location.name }}
        </mat-option>
      }
    </mat-select>
  </div>
  <div class="col-sm-12 col-lg-3 col-xl-2 align-self-end">
    <label class="font-weight-bold">Meal <span class="font-weight-normal small">(Optional)</span>:</label>
    <mat-select
      placeholder='-- Select A Meal --'
      class="btn avi-btn py-2 px-2 meal-select"
      aria-label="Meal Select"
      (selectionChange)="mealChanged($event)"
      [ngClass]="isMealDisabled ? 'btn-secondary': 'btn-primary'"
      [disabled]="isMealDisabled"
      >
      @for (meal of selectedLocationMeals$ | async; track meal) {
        <mat-option
          [value]="meal.id"
          >
          @if (
            (currentClient$ | async).showMealTimes) {
            {{ meal.name }} :
            {{
            meal.startTime
            | convertUTC
            : (currentSelectedLocation$ | async)
            .timeZone
            }}
            -
            {{
            meal.endTime
            | convertUTC
            : (currentSelectedLocation$ | async)
            .timeZone
            }}
          } @else {
            {{ meal.name }}
          }
        </mat-option>
      }
    </mat-select>
  </div>
  <ng-content></ng-content>
</div>
